(function () {
    const button = document.getElementById("obfuscateBtn");

    // Add the event listener
    button.addEventListener("click", function () {
        // Obfuscate email
        const emailParts = ["geniusdogsgr", "gmail.com"]; // Replace with your email
        const email = document.getElementById("eml");
        if (email) {
            // email.innerHTML = `<a href="mailto:${emailParts[0]}@${emailParts[1]}">${emailParts[0]}@${emailParts[1]}</a>`;
            email.innerHTML = `${emailParts[0]}@${emailParts[1]}`;
            email.href = `mailto:${emailParts[0]}@${emailParts[1]}`;
        } else {
            console.error("Element with ID 'eml' not found.");
        }

        // Obfuscate phone number
        const phoneParts = ["+30", "690", "639", "6321"]; // Replace with your phone number
        const phoneNumber = document.getElementById("phnnbr");
        if (phoneNumber) {
            phoneNumber.innerHTML = phoneParts.join(" ");
            phoneNumber.href = "tel:" + phoneParts.join("");
        } else {
            console.error("Element with ID 'phnnbr' not found.");
        }

        // Select all elements with the class 'contact-row'
        const contactRows = document.querySelectorAll('.contact-row');

        // Loop through each element and change the display property
        contactRows.forEach(function (row) {
            row.style.display = 'flex';
        });

        // Remove the button
        button.style.display = 'none';
    });
})();